<template>
    <div class="no_msg_content">
        <img src="static/images/no_msg.png" />
        <span>暂无数据</span>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>

.no_msg_content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
}

.no_msg_content > span {
    margin-top: 20px;
    font-size: 16px;
    color: #333;
}

</style>


// WEBPACK FOOTER //
// src/components/component/nomsg.vue